import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance with auth token
export const createAuthAPI = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
};

export const login = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, { email, password });
  const { token, role, user_id, client_id } = response.data;
  
  localStorage.setItem('token', token);
  localStorage.setItem('role', role);
  localStorage.setItem('user_id', user_id);
  if (client_id) localStorage.setItem('client_id', client_id);
  
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('user_id');
  localStorage.removeItem('client_id');
};

export const getAuthToken = () => localStorage.getItem('token');
export const getRole = () => localStorage.getItem('role');
export const getUserId = () => localStorage.getItem('user_id');
export const getClientId = () => localStorage.getItem('client_id');